import styles from "./Router.module.css";

import { useCallback, useContext, useEffect, useRef, useState } from "react";
import AvailabilityCheck from "./1_Availability_check/AvailabilityCheck";
import ServiceSelection from "./2_ServiceSelection/ServiceSelection";
import OrderForm from "./5_OrderForm/OrderForm";
import Loader from "../UI/Loader";
import DataContext from "../store/data-context";
import SelectedService from "./3_SelectedService/SelectedService";
import NoServicesAvailableAlert from "../UI/Error";
import AnimationContainer from "../UI/AnimationContainer";
import HelperContainer from "./Navigation/NavigationBar";
import Error from "../UI/Error";
import logo from "../../assets/logo.png";

export default function Router({ closeApp }) {
    const {
        error,
        setError,
        loading,
        location,
        processIndex,
        setProcessIndex,
    } = useContext(DataContext);

    const [splashIsActive, setSplashIsActive] = useState(true);

    useEffect(() => {
        if (!location) {
            setProcessIndex("availability_check");
        }
    }, [location]);

    useEffect(() => {
        if (processIndex < 0 && processIndex > 6) {
            setProcessIndex(0);
        }
    }, [processIndex]);

    return (
        <>
            {error && (
                <Error
                    message={error.message}
                    action={error.action}
                    onClose={() => setError()}
                />
            )}
            {loading && <Loader />}

            <div className={`${styles.App}`}>
                <AnimationContainer
                    processIndex={processIndex}
                    componentIndex={"availability_check"}
                    children={
                        <AvailabilityCheck
                            splashIsActive={splashIsActive}
                            setSplashIsActive={setSplashIsActive}
                        />
                    }
                />

                <AnimationContainer
                    processIndex={processIndex}
                    componentIndex={"service_selection"}
                    children={
                        <ServiceSelection setProcessIndex={setProcessIndex} />
                    }
                />

                <AnimationContainer
                    processIndex={processIndex}
                    componentIndex={"selected_service"}
                    children={<SelectedService />}
                />

                <AnimationContainer
                    processIndex={processIndex}
                    componentIndex={"order_form"}
                    children={<OrderForm />}
                />
            </div>
            <HelperContainer
                processIndex={processIndex}
                setProcessIndex={setProcessIndex}
                closeApp={closeApp}
            />
        </>
    );
}
